module.exports = __webpack_public_path__ + "static/media/add_new_child.fdfa0ff1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/add_new_child.svg
// module id = 313
// module chunks = 21